<template>
  <div class="testimonails-slider__slides">
    <ClientOnly>
      <swiper-container
        :slides-per-view="1"
        space-between="32"
        :breakpoints="{
          768: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
          },
        }"
        :pagination="{
          el: swiperPagination,
          clickable: false,
        }"
        ref="swiperContainer"
        class="testimonials-slider__slider"
      >
        <swiper-slide class="testimonials-slider__slider-item testimonial bg-white rounded-md p-6 flex flex-col gap-6 h-auto" v-for="(testimonial, i) in testimonials" :key="i">
          <Stars :stars="testimonial.stars" />
          <p class="testimonial__text text-medium-normal lg:h-72 overflow-auto" tabindex="0">"<span v-html="wrapEmoji(testimonial.testimonial)" />"</p>
          <div class="testimonial__author flex gap-4">
            <div class="testimonial-author flex flex-col gap-1">
              <p class="testimonial-author__name text-regular-semibold">{{ testimonial.name }}</p>
            </div>
          </div>
        </swiper-slide>
      </swiper-container>
    </ClientOnly>
    <div class="testimonials-slider__slider-controls flex justify-between items-center mt-10">
      <div class="testimonials-slider__pagination w-full flex gap-2" ref="swiperPagination"></div>
      <div class="testimonials-slider__navigation flex items-center gap-4">
        <SharedIconButton variant="accent" @click="swiper?.prev()" icon="arrow-left" class="w-10 h-10" :aria-label="t('swiper.previous')" :title="t('swiper.previous')"
          ><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M12.7069 17.293L8.41394 13H17.9999V11H8.41394L12.7069 6.70697L11.2929 5.29297L4.58594 12L11.2929 18.707L12.7069 17.293Z" fill="currentColor" />
          </svg>
        </SharedIconButton>
        <SharedIconButton variant="accent" @click="swiper?.next()" icon="arrow-right" class="w-10 h-10" :aria-label="t('swiper.next')" :title="t('swiper.next')">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M11.2931 17.293L15.5861 13H6.00006V11H15.5861L11.2931 6.70697L12.7071 5.29297L19.4141 12L12.7071 18.707L11.2931 17.293Z" fill="currentColor" />
          </svg>
        </SharedIconButton>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { GraphQLTestimonial } from '~/types/graphql';
  import type { SwiperContainer } from 'swiper/element';
  import Stars from './Stars.vue';

  const { t } = useI18n();
  withDefaults(
    defineProps<{
      testimonials: GraphQLTestimonial[];
      loading: 'eager' | 'lazy';
    }>(),
    {
      loading: 'lazy',
    }
  );

  const swiperPagination = ref<HTMLElement | null>(null);
  const swiperContainer = ref<SwiperContainer | null>(null);

  const swiper = useSwiper(swiperContainer, {});
</script>

<style scoped lang="scss">
  .testimonials-slider__pagination {
    &:deep(.swiper-pagination-bullet) {
      @apply size-2 rounded-full bg-white;
      @apply mx-0;
      @apply opacity-20;
      @apply pointer-events-none;
    }
    &:deep(.swiper-pagination-bullet-active) {
      @apply bg-white;
      @apply opacity-100;
    }
  }
</style>
